import styled from 'styled-components';

export const Container = styled.div`
  margin: 0 0 70px;
`;

export const Content = styled.div``;
